import APICall from '../utils/APICall';

export default class RoleServices {

    static listRoles = async (page, pageLimit, search) => {
        return await APICall(`/api/Role/admin/listRoles?page=${page}&pageLimit=${pageLimit}&search=${search}`, "GET");
    }
    static viewRole = async (roleName) => {
        return await APICall(`/api/Role/admin/viewRole?roleName=${roleName}`, "GET");
    }
    static createRole = async (payload) => {
        return await APICall(`/api/Role/admin/create-role`, "POST", payload);
    }
    static updateRole = async (payload) => {
        return await APICall('/api/Role/admin/update-role', "POST", payload);
    }
}